import React, { Component } from 'react';

import './message-display.css';


export default class MessageDisplay extends Component {
    // Currently this just relays the message to the menu message display.
    constructor(props) {
        super(props);
        this.state = {
            message: 'Welcome'
        };
        props.app.gameController.messageDisplay.messageDisplay2d = this;
        this.menu2d = props.app.gameController.menu2d;
    }

    componentWillUnmount() {
        this.props.app.gameController.messageDisplay.messageDisplay2d = null;
    }

    displayMessage = (message) => {
        this.setState({message: message});
        this.menu2d.displayMessage(message);
    }

    render() {
        let gamePlayerData = this.props.gamePlayerData;
        if (!gamePlayerData) return <></>

        if (!gamePlayerData.current_choice) return <></>

        return (
            <div id={'message-display-anchor'} className={'message-display-anchor'}>
            <div id={'message-display'}
                 className={'message-display'}
            >
                <div className={'message-display-text'}
                >
                    {this.state.message}
                </div>
            </div>
            </div>
        );
    }
}
